$(function(){
    $('.login-wrapper input').placeholder();
    $('.input-group.terms-conditions input').change(function(event) {
        console.log(event);
    });
    var device;
    var client = new ClientJS();
    device = (client.getDevice() === undefined) ? client.getOS() : client.getDevice();

    $('#device').val(device);

    $("#registration_type").change(function () {
        if($(this).find(':selected').data('representing')=='1'){
            $("#representing").show();
        } else {
            $("#representing").hide();
        }

    });
});